import React, { useState } from 'react';
import styles from './ChangePasswordModal.module.css';
import { ChangePasswordIcon } from '../../assets/icons';
import { updateUser } from '../../services/updateUser.service';

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId: number;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  isOpen,
  onClose,
  userId,
}) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setError('');
    setLoading(true);
    setSuccess('');
    try {
      await updateUser({ id: userId, password: newPassword });
      setSuccess('Password changed successfully');
      setTimeout(() => {
        setLoading(false);
        setSuccess('');
        onClose();
      }, 1000);
    } catch (err: any) {
      setError(err?.message || 'Failed to change password');
      setLoading(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button
          className={styles.closeBtn}
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <div className={styles.title}>Change Password</div>
        <form onSubmit={handleSubmit} className={styles.form}>
          <label className={styles.label}>
            Write New Password
            <div className={styles.inputWrapper}>
              <span className={styles.icon}>
                <ChangePasswordIcon />
              </span>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className={styles.input}
                required
                placeholder="Write New Password"
              />
            </div>
          </label>
          <label className={styles.label}>
            Confirm Password
            <div className={styles.inputWrapper}>
              <span className={styles.icon}>
                <ChangePasswordIcon />
              </span>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className={styles.input}
                required
                placeholder="Confirm Password"
              />
            </div>
          </label>
          {error && <div className={styles.error}>{error}</div>}
          {success && <div className={styles.success}>{success}</div>}
          <button type="submit" className={styles.submitBtn} disabled={loading}>
            {loading ? 'Changing...' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
